import React, { useState } from 'react';
import './ExpenseForm.css';

const ExpenseForm = (props) => {

    const [enteredTitle, setEnteredTitle] = useState('');
    const [enteredAmount, setEnteredAmount] = useState('');
    const [enteredDate, setEnteredDate] = useState('');
    
    const titleChangeHandler = () => {
        //eslint-disable-next-line no-restricted-globals
        setEnteredTitle(event.target.value);
    };

    const amountChangeHandler = event => {
        setEnteredAmount(event.target.value);
    };

    const dateChangeHandler = event => {
        setEnteredDate(event.target.value);
    };

    const submitHandler = () => {
        //eslint-disable-next-line no-restricted-globals
        event.preventDefault();
        const expenseData = {
            title: enteredTitle,
            amount : enteredAmount,
            date : new Date(enteredDate)
        };
        props.onSaveExpenseData(expenseData);
        setEnteredTitle('');
        setEnteredAmount('');
        setEnteredDate('');
    };
 return (
    
         <form onSubmit={submitHandler}>
             <div className='new-expense__controls'>
                 <div className='new-expense__control'>
                     <label>Enter Title</label>
                     <input type='text ' value={enteredTitle} onChange={titleChangeHandler}/>
                 </div>
                 <div className='new-expense__control'>
                     <label>Enter Amount</label>
                     <input type='number' min='0' step='0.01' value={enteredAmount} onChange={amountChangeHandler}/>
                 </div>
                 <div className='new-expense__control'>
                     <label>Enter Date</label>
                     <input type='date' min='2015-01-01' max='2025-12-31' value={enteredDate} onChange={dateChangeHandler}/>
                 </div>
             </div>
             <div className='new-expense__actions'>
                 <button type='button' onClick={ props.onCancel}>Cancel</button>
                 <button type='submit'>ADD EXPENSE</button>
             </div>
         </form>
     
 );
};

export default ExpenseForm;